var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dialog',{attrs:{"visible":_vm.showModal,"top":"30vh","width":"820px"},on:{"close":_vm.onClose}},[_c('div',{staticClass:"md-Message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }